export enum BreadcrumbStatusEnum {
  VISITED = "VISITED",
  CURRENT = "CURRENT",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED"
}
